export const environment = {
  production: false,
  // apiUrl: 'http://localhost:3000',
  // baseUrl:'http://192.168.2.141:16004/api/'
  // baseUrl: 'https://preprodtdcdm-boapi.smartsortsupport.com/api/',
    // baseUrl:'http://10.0.2.55:16004/api/'
    // baseUrl : 'https://uat-tdcdm-boapi.smartsortsupport.com/api/'
    baseUrl : 'https://tdcdm-boapi.smartsortsupport.com/api/'
  // baseUrl: 'https://tdcdm-boapi.smartsortsupport.com/api/'
};
